import { FC } from 'react';
export type CloseButtonProps = Readonly<{
  onClick: () => void;
}>;

export const CloseButton: FC<CloseButtonProps> = ({ onClick }) => {
  return (
    <div className="header d-flex flex-row-reverse justify-content-between w-100 position-absolute">
      <div className="btn-group p-12px d-none d-lg-flex" style={{ zIndex: 1000 }}>
        <button
          type="button"
          className="btn btn-icon btn-flat-white btn-lg bg-dark bg-opacity-50 bg-blur"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={onClick}
        >
          <i className="icon text-white">clear</i>
        </button>
      </div>
    </div>
  );
};
